import { observer } from 'mobx-react';
import React, { useCallback, useMemo } from 'react';
import { useCheckoutStoreContext } from '../../context';
import { ICheckoutDependencies } from 'src/mobx/checkoutStore/types';
import { transformToPickerOption } from 'src/view/components/Controls/Pickers/Picker/helpers';
import Picker from 'src/view/components/Controls/Pickers/Picker/Picker';
import { IPickerOption } from 'src/view/components/Controls/Pickers/Picker/types';
import Text, { TEXT } from 'src/view/components/Text/Text';

const OrderDineIn: React.FC = observer((): JSX.Element => {
  const { store: checkoutStore } = useCheckoutStoreContext();

  const changeDineInInfo = useCallback(
    (field: keyof ICheckoutDependencies['dinein']) => (options: IPickerOption[]) => {
      const option: IPickerOption | undefined = options[0];
      checkoutStore.changeDineInInfo(field, option ? { id: option.value, name: option.label } : undefined);
    },
    []
  );

  const sectionPickerOptions = useMemo((): IPickerOption[] => {
    const sections = checkoutStore.dependencies.emenu.data?.sections;
    return sections ? sections.map((section) => transformToPickerOption(section)) : [];
  }, [checkoutStore.dependencies.emenu.data]);

  const sectionValue = useMemo((): IPickerOption[] | undefined => {
    return checkoutStore.dependencies.dinein.section?.id ? [transformToPickerOption(checkoutStore.dependencies.dinein.section)] : undefined;
  }, [checkoutStore.dependencies.dinein.section]);

  const tablePickerOptions = useMemo((): IPickerOption[] => {
    const section = checkoutStore.dependencies.emenu.data?.sections.find((_section) => _section.id === checkoutStore.dependencies.dinein.section?.id);
    return section ? section.tables.map((table) => transformToPickerOption(table)) : [];
  }, [checkoutStore.dependencies.emenu.data, checkoutStore.dependencies.dinein.section?.id]);

  const tableValue = useMemo((): IPickerOption[] | undefined => {
    return checkoutStore.dependencies.dinein.table?.id ? [transformToPickerOption(checkoutStore.dependencies.dinein.table)] : undefined;
  }, [checkoutStore.dependencies.dinein.table]);

  return (
    <div className="d-flex flex-column">
      {/* section picker */}
      <div className="d-flex align-items-center mb-3">
        <Text type={TEXT.ORDER_FIELD} text="section" required />
        <Picker
          onSelect={changeDineInInfo('section')}
          selectedOptions={sectionValue}
          options={sectionPickerOptions}
          loading={checkoutStore.dependencies.emenu.loading}
          disabled={checkoutStore.dependencies.emenu.loading}
          validation={{ isValid: !checkoutStore.validatorErrors.section }}
          hideSelectedIcons
          numberVisibleOptionsInDropdown={5}
          listPlacement="top"
          placeholder="section"
          defaultPlaceholderClassName="color-gray2"
        />
      </div>
      {/* table picker */}
      <div className="d-flex align-items-center mb-3">
        <Text type={TEXT.ORDER_FIELD} text="txt_table" required />
        <Picker
          onSelect={changeDineInInfo('table')}
          selectedOptions={tableValue}
          options={tablePickerOptions}
          loading={checkoutStore.dependencies.emenu.loading}
          disabled={!checkoutStore.dependencies.dinein.section?.id || checkoutStore.dependencies.emenu.loading}
          validation={{ isValid: !Boolean(checkoutStore.dependencies.dinein.section?.id && checkoutStore.validatorErrors.table) }}
          hideSelectedIcons
          numberVisibleOptionsInDropdown={5}
          listPlacement="top"
          placeholder="txt_table"
          defaultPlaceholderClassName="color-gray2"
        />
      </div>
    </div>
  );
});

export default OrderDineIn;
